import http from "@/http";

export default class ApiResource {
    static sendData(data) {
        return http.post("/create", data);
    }
}
